import React, { memo, useCallback } from 'react';

import { View, Text, StyleSheet } from 'react-native';

import {
  Container,
  ArrowButton,
  IconButton,
  IconRow,
  I18n,
  Avatar,
  Navigation,
  ClipboardTouchable,
  ParsedText,
} from '../components';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { setEditingPatient } from '../patient/actions';

import { getEditingCaseWithFiles, getEditingCasePatient } from './selector';

const CaseInfoConsumer = memo((props) => {
  const goToPatient = useCallback(() => {
    const patient = props.editingCasePatient;
    if (patient) {
      props.actions.setEditingPatient(patient.patientId);
      Navigation.push(
        {
          screen: 'PatientInfo',
          title: I18n.t('patient.patientInfo'),
        },
        props.componentId
      );
    } else {
      Navigation.push(
        {
          screen: 'PatientForm',
          title: I18n.t('patient.patientInfo'),
        },
        props.componentId
      );
    }
  }, [props.editingCasePatient]);

  const goToInvite = useCallback(() => {
    Navigation.push(
      {
        screen: 'Invite',
        title: I18n.ac('invite.invitePeople'),
        passProps: {
          editingCase: true,
          noBacksies: false,
        },
      },
      props.componentId
    );
  }, []);

  return (
    <Container
      actionSheet={true}
      scrollView={true}
      renderActivityOverlay={!props.editingCase}
      successMessage={props.caseCreateSuccessMessage}
    >
      {!!props.editingCase && (
        <>
          <View style={styles.header}>
            <Avatar
              initialsStr={props.editingCase.name}
              onPress={null}
              attachment={props.editingCase.avatar}
            />
            <Text style={styles.headerText}>{props.editingCase.name}</Text>
          </View>

          <View>
            <View style={styles.notesContainer}>
              <ClipboardTouchable text={props.editingCase.description}>
                <ParsedText style={styles.notesValueText}>
                  {props.editingCase.description}
                </ParsedText>
              </ClipboardTouchable>
            </View>
            <IconRow
              imageSource={require('../../../resources/icon-time.png')}
              label={I18n.t('calendar.timeZone')}
              value={props.editingCase.timeZone}
              topBorder={true}
            />
            <IconRow
              imageSource={null}
              value={props.editingCase.ailment}
              label={I18n.ce('case.ailment')}
              topBorder={false}
              bottomBorder={false}
            />
          </View>

          <IconButton
            label={I18n.t('patient.patient')}
            value={props.editingCasePatient?.fullName || props.editingCase.patientName}
            imageSource={require('../../../resources/icon-user.png')}
            onPress={goToPatient}
          />

          <ArrowButton
            value={I18n.t('case.inviteOthersToCase')}
            onPress={goToInvite}
            noTopBorder={true}
          />
        </>
      )}
    </Container>
  );
});
CaseInfoConsumer.displayName = 'CaseInfoConsumer';

const styles = StyleSheet.create({
  header: {
    ...THEME.header,
    alignItems: 'center',
  },
  headerText: {
    ...THEME.headerText,
    marginTop: 10,
  },
  notesContainer: {
    paddingVertical: 20,
    paddingHorizontal: 25,
  },
  notesLabelText: {
    ...FONT.light,
    fontSize: FONT_SIZE.small,
    color: COLOR.text,
    marginBottom: 7,
  },
  notesValueText: {
    ...FONT.regular,
    fontSize: FONT_SIZE.xlarge,
    color: COLOR.text,
  },
});

function mapStateToProps(state, ownProps) {
  return {
    editingCase: getEditingCaseWithFiles(state),
    editingCasePatient: getEditingCasePatient(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        setEditingPatient,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseInfoConsumer);
